import Slides from './Slides';
import SlideDeck from './SlideDeck';
import SlideDeckControls from './SlideDeckControls';

export {
    Slides,
    SlideDeckControls
};

export default SlideDeck;
